<button *ngIf="!settings"
	#button
	mat-raised-button
	type="button"
    (click)="buttonClicked($event)"
    [disableRipple]="true"
    [disabled]="disabled"
    [style.height]="height || '50px'"
	[style.width]="width || '100%'"
    [style.margin-right]="mgr || '0px'"
    [ngClass]="disabled === true ? 'disabled' : color"
>
    <mat-spinner *ngIf="busy" [color]="'primary'" [diameter]="27" [strokeWidth]="4"></mat-spinner>
    <div class="content" *ngIf="!busy">{{ text }}</div>
</button>
<button
    *ngIf="settings && !settings.offer"
    (click)="onButtonClick($event)"
    mat-raised-button
    [color]="settings.layout"
    [disabled]="(settings.disabled) ? 'disabled' : null"
    [class.active]="active"
>

    <span
        *ngIf="settings && settings.label && settings.label.position && settings.label.position === 'before'"
        class="button-label before"
    >
        {{settings.label.text}}
    </span>

    <img
        *ngIf="settings && settings && settings.icon"
        [src]="settings.icon"
        class="button-icon"
    >
    <span
        *ngIf="(settings && settings.label && settings.label.text && !settings.label.position)"
        class="button-label after"
    >
        {{settings.label.text}}
    </span>
</button>

<button
    *ngIf="settings && settings.offer && settings && settings.layout"
    mat-raised-button
    color="{{settings.layout}}"
    [disabled]="(settings.disabled) ? 'disabled' : null"
    [class.active]="settings.active"
    [class.active]="active"
    [class.small]="settings.small"
    [class.simpler]="settings.simpler"
    (click)="onButtonClick()"
>
    <span class="button-cta-offer-container">
        <img
            [src]="settings.offer.image"
            class="button-cta-offer-image"
            *ngIf="settings.offer && settings.offer.image"
        >
        <span
            class="button-cta-offer-title"
            *ngIf="settings.offer && settings.offer.title"
        >
            {{settings.offer.title}}
            <span
                class="button-cta-offer-title-suffix"
                *ngIf="settings.offer && settings.offer.titleSuffix"
            >
                {{settings.offer.titleSuffix}}
            </span>
        </span>

        <span
            class="button-cta-offer-details"
            *ngIf="settings.offer && settings.offer.details"
        >
            {{settings.offer.details}}
        </span>
        <span
            class="button-cta-offer-price"
            *ngIf="settings.offer && settings.offer.price && settings.offer.price.position==='bottom'"
        >
            <span
                class="button-cta-offer-price-details"
                *ngIf="settings.offer.price.details"
            >
                {{settings.offer.price.details}}
            </span>
            <span
                class="button-cta-offer-price-amount"
                *ngIf="settings.offer.price.amount"
            >
                ${{settings.offer.price.amount}}
            </span>
            <span
                class="button-cta-offer-price-occurance"
                *ngIf="settings.offer.price.occurance"
            >
                {{settings.offer.price.occurance}}
            </span>
        </span>
    </span>
</button>
